import { getImageSrc } from '@captaincause/lib/getImageSrc'
import smallLaurier from '../assets/gem-small-laurier.svg?inline'
import { tm } from '../tm'
import i18n from './i18n'
import type { Locales, Project } from '@captaincause/types'

interface ProjectGemBadgeProps {
  project: Project
  locale: Locales
  className?: string
}

export function ProjectGemBadge({
  project,
  locale,
  className = '',
}: ProjectGemBadgeProps) {
  const t = i18n[locale] ?? i18n.fr

  if (!project.promo) {
    return null
  }

  const laurier = getImageSrc(smallLaurier)

  return (
    <div
      className={tm(
        'relative flex w-fit items-center gap-1 rounded-full text-sm',
        className,
      )}
    >
      <img src={laurier} alt="" className="h-6 opacity-40" />
      <span className="text-center text-xs font-semibold leading-[18px] -tracking-[0.12px] text-white">
        {t.gem}
      </span>
      <img
        src={laurier}
        alt=""
        className="h-6 opacity-40 [transform:rotateY(180deg)]"
      />
    </div>
  )
}
